/* @ngInject */
function taskTagsService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    createTaskTag,
    getTaskTags,
    getTaskTagsSuggestions,
    updateTaskTagsById,
    deleteTaskTag,
    updateTaskTag
  }
  return service

  function createTaskTag (label) {
    return ConnectorWebService.post(CONSTANTS.URL_TASK_TAGS, { label })
  }

  function getTaskTags (params) {
    const { top, skip, search, taskCount, sort, order } = params
    let url = CONSTANTS.URL_TASK_TAGS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (taskCount) {
      url = Utils.fnAddQueryToUrl(url, { taskCount })
    }

    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort })
    }

    if (order) {
      url = Utils.fnAddQueryToUrl(url, { $order: order })
    }

    return ConnectorWebService.get(url)
  }

  function getTaskTagsSuggestions (excludedTags) {
    let url = CONSTANTS.URL_TASK_TAGS_SUGGESTIONS

    if (excludedTags && excludedTags.length) {
      url = Utils.addQueryStringFromArray(url, 'excludedTags', excludedTags)
    }

    return ConnectorWebService.get(url)
  }
  /**
   * Updates the tags associated with a task/user request
   * @param {number} id - The task ID
   * @param {Array} tags - Array of tag IDs to associate with the task
   * @returns {Promise} Promise that resolves when tags are updated
   */

  function updateTaskTagsById (id, tags) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_TAGS, [id])
    return ConnectorWebService.put(url, { tags })
  }

  function deleteTaskTag (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASK_TAGS_ID, [id])
    return ConnectorWebService.fnDelete(url)
  }

  function updateTaskTag (id, label) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASK_TAGS_ID, [id])
    return ConnectorWebService.put(url, { label })
  }
}

export { taskTagsService }
